import axios from "axios";
const stripeAPI = axios.create({
  baseURL: "/api/stripe/",
});

export default stripeAPI;
